/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const factory_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 17.25h3m-3 3h3m3-3h3m-3 3h3M9.005.869A6.954 6.954 0 0 1 12 1.491C19.429 4.662 22.5.75 22.5.75m-1.855 10.326c.363.225.293.312.355.424v10.25a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V13.5S3.742 3 4.356 3h1.788C6.5 3 9 13.5 9 13.5s5.147-2.457 5.645-2.424c.119.008.355 2.424.355 2.424s5.281-2.648 5.645-2.424Z"
    />
  </svg>
)
export default factory_medium
